import {Injectable} from '@angular/core';
import {CompoApiService, ApiResponse} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {RemindData} from '../interfaces/RemindData';

@Injectable({
  providedIn: 'root',
})
export class ForgotService {
  constructor(private readonly apiService: CompoApiService) {
  }

  public remind(remindData: RemindData): Observable<ApiResponse<string>> {
    return this.apiService.post<RemindData, string>('/remind/', remindData);
  }
}
